import React from 'react';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-16 bg-bg-card border-t border-border-medium">
      <div className="container mx-auto px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-4 gap-12 mb-12">
            {/* Brand & Description */}
            <div className="lg:col-span-2">
              <div className="mb-6">
                <h3 className="heading-4 text-brand-primary mb-4">Anna Krat</h3>
                <p className="body-medium text-text-primary mb-4">
                  Technical Product & Digital Transformation Professional
                </p>
                <p className="body-small text-text-secondary max-w-md">
                  Helping organisations turn complex operational, data, compliance and security challenges into secure, scalable and user-centred digital solutions.
                </p>
              </div>

              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <Mail size={16} className="text-brand-primary" />
                  <a 
                    href="mailto:anna200224@hotmail.com"
                    className="body-small text-text-secondary hover:text-brand-primary transition-colors"
                  >
                    anna200224@hotmail.com
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone size={16} className="text-brand-primary" />
                  <a 
                    href="tel:+447918663773"
                    className="body-small text-text-secondary hover:text-brand-primary transition-colors"
                  >
                    +44 791 866 3773
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin size={16} className="text-brand-primary" />
                  <span className="body-small text-text-secondary">Glasgow, UK</span>
                </div>
              </div>
            </div>

            {/* Quick Navigation */}
            <div>
              <h4 className="heading-6 text-text-primary mb-6">Navigation</h4>
              <nav className="space-y-3">
                <button 
                  onClick={() => scrollToSection('home')}
                  className="block body-small text-text-secondary hover:text-brand-primary transition-colors text-left"
                >
                  Home
                </button>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="block body-small text-text-secondary hover:text-brand-primary transition-colors text-left"
                >
                  About Me
                </button>
                <button 
                  onClick={() => scrollToSection('skills')}
                  className="block body-small text-text-secondary hover:text-brand-primary transition-colors text-left"
                >
                  Skills
                </button>
                <button 
                  onClick={() => scrollToSection('experience')}
                  className="block body-small text-text-secondary hover:text-brand-primary transition-colors text-left"
                >
                  Experience
                </button>
                <button 
                  onClick={() => scrollToSection('projects')}
                  className="block body-small text-text-secondary hover:text-brand-primary transition-colors text-left"
                >
                  Projects
                </button>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="block body-small text-text-secondary hover:text-brand-primary transition-colors text-left"
                >
                  Contact
                </button>
              </nav>
            </div>

            {/* Expertise Areas */}
            <div>
              <h4 className="heading-6 text-text-primary mb-6">Expertise</h4>
              <ul className="space-y-3">
                <li className="body-small text-text-secondary">Product & Digital Transformation</li>
                <li className="body-small text-text-secondary">Enterprise Systems Implementation</li>
                <li className="body-small text-text-secondary">Data Governance & Data Quality</li>
                <li className="body-small text-text-secondary">GDPR & ISO 27001-aligned Controls</li>
                <li className="body-small text-text-secondary">Workflow Automation (M365, Power Automate)</li>
                <li className="body-small text-text-secondary">AI-assisted Digital Platforms</li>
              </ul>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-border-medium pt-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              {/* Copyright */}
              <div className="flex items-center space-x-2">
                <span className="caption text-text-secondary">
                  © {currentYear} Anna Krat. Product, transformation and governance-led delivery.
                </span>
              </div>

              {/* Back to Top */}
              <button 
                onClick={scrollToTop}
                className="btn-secondary text-sm"
              >
                Back to Top
              </button>
            </div>

            {/* Professional Statement */}
            <div className="mt-6 p-4 bg-bg-page border border-border-medium rounded-lg">
              <p className="caption text-text-secondary text-center">
                Open to senior UK roles in Technical Product, Product Operations, Digital Transformation, Data Governance and Delivery • Available to discuss opportunities
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;